import { Col, CreateTableState, Grid } from 'gu-ui-kit'
import React, { useEffect, useMemo, useState } from 'react'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import {
  AliasCell,
  PartnerPercentCell,
  HeadCell,
  ClientPercentCell,
  TotalPercentCell,
} from 'modules/Forms/Referral/LinkForm/subcomponents/FinancialTerms/subcomponents'
import styles from 'modules/Forms/Referral/LinkForm/subcomponents/FinancialTerms/financial-terms.module.scss'

export const useTableConfig = ({ isEditForm = false }, data = []) => {
  const breakpoints = useBreakpoint()
  const [columnVisibility, setColumnVisibility] = useState()

  useEffect(() => {
    switch (true) {
      case breakpoints.fbs:
        setColumnVisibility({
          total_percent: false,
          client_percent: false,
          referral_percent: false,
        })
        break
      default:
        setColumnVisibility({})
        break
    }
  }, [breakpoints])

  const tableConfig = useMemo(
    () => ({
      columns: [
        {
          id: 'financial_profile_type_alias',
          header: <HeadCell alias={'payment_method'} tooltip={false} />,
          className:
            styles['financial-terms__cell_financial-profile-type-alias'],
          cell: ({ row: { original } }) => (
            <Grid
              direction={'row'}
              cols={2}
              wrap={true}
              alignItems={'center'}
              gap={12}
            >
              <Col style={{ width: '100%' }}>
                <AliasCell {...original} />
              </Col>
              {breakpoints.fbs && (
                <>
                  <Col>
                    <HeadCell alias={'current_percent'} />
                  </Col>
                  <Col>
                    <TotalPercentCell
                      className={'padding-left-16'}
                      {...original}
                    />
                  </Col>

                  <Col>
                    <HeadCell alias={'partner_percent'} />
                  </Col>
                  <Col>
                    <PartnerPercentCell
                      className={'padding-left-16'}
                      {...original}
                    />
                  </Col>
                  <Col>
                    <HeadCell alias={'client_percent'} />
                  </Col>
                  <Col>
                    <ClientPercentCell disabled={isEditForm} {...original} />
                  </Col>
                </>
              )}
            </Grid>
          ),
        },
        {
          id: 'total_percent',
          header: <HeadCell alias={'current_percent'} />,
          className: styles['financial-terms__cell_total-percent'],
          cell: ({ row: { original } }) => <TotalPercentCell {...original} />,
        },
        {
          id: 'referral_percent',
          header: <HeadCell alias={'partner_percent'} />,
          className: styles['financial-terms__cell_total-percent'],
          cell: ({ row: { original } }) => <PartnerPercentCell {...original} />,
        },
        {
          id: 'client_percent',
          header: <HeadCell alias={'client_percent'} />,
          className: styles['financial-terms__cell_referral-percent'],
          cell: ({ row: { original } }) => (
            <ClientPercentCell {...original} disabled={isEditForm} />
          ),
        },
      ],
      state: {
        columnVisibility,
      },
      showHeader: !breakpoints.fbs,
      showFooter: false,
      className: styles['financial-terms__table'],
      skin: 'compact',
    }),
    [isEditForm, columnVisibility],
  )

  return {
    tableState: CreateTableState(tableConfig, data),
    tableConfig,
  }
}
